import { createSlice } from '@reduxjs/toolkit';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from '../common/reducers/utilities';
import { ensureArray } from '../common/utils/arrayUtilities';

const compareRefDocs = (s1, s2) => s1.id === s2.id

const refDocSlice = createSlice({
    name: 'refDocs',
    initialState: {
        data: []
    },
    reducers: {
        set: (state, action) => {
            state.data = action.payload
        },
        addOrUpdate: (state, action) => {
            for (const refDoc of ensureArray(action.payload)) {
                let idx = state.data.findIndex(rd => compareRefDocs(refDoc, rd));
                if (idx >= 0) {
                    state.data.splice(idx, 1, refDoc);
                } else {
                    state.data.push(refDoc);
                }
            }
        },
        remove: (state, action) => {
            for (const refDoc of ensureArray(action.payload)) {
                let idx = state.data.findIndex(rd => compareRefDocs(rd, refDoc));
                if (idx >= 0) {
                    state.data.splice(idx, 1);
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => refDocSlice.getInitialState());
    }
});

// #region network operations
const fetchRefDocs = network => network.get('/api/v1/refdocs', refDocSlice.actions.set);
export const fetchRefDoc = async (network, id) => network.fetchData('/refDoc/' + encodeURIComponent(id));
export const addRefDoc = (network, data) => network.postData('/api/v1/refDoc', data);
export const removeRefDoc = (network, id) => network.delete('/api/v1/refDoc/' + encodeURIComponent(id), refDocSlice.actions.remove);
// #endregion

// #region permission checks
export const canCreateRefDoc = (credentials, refDoc) => credentials.access.hasFull('administrator');
export const canRemoveRefDoc = (credentials, refDoc) => credentials.access.hasFull('administrator');
// #endregion

// #region selectors
const selectRefDocs = state => state.refDocs.data;
// #endregion

// #region listeners
const listen = {
    refDocCreated: (refDoc, { dispatch }) => dispatch(refDocSlice.actions.addOrUpdate(refDoc)),
    refDocUpdated: (refDoc, { dispatch }) => dispatch(refDocSlice.actions.addOrUpdate(refDoc)),
    refDocRemoved: (refDoc, { dispatch }) => dispatch(refDocSlice.actions.remove(refDoc))
}
// #endregion

export const [useRefDocs] = dataHookFactory(selectRefDocs, { run: fetchRefDocs, listen });

const reducerDetails = { name: refDocSlice.name, reducer: refDocSlice.reducer };
export default reducerDetails;